import { Box, Flex, BoxProps } from '@chakra-ui/react'
import curveImg from 'assets/img/curve.svg'
import frameImg from 'assets/img/frame.png'

const Layout: React.FC = ({ children }) => {
  const absoluteBox: BoxProps = {
    pos: 'absolute',
    top: '0',
    left: '0',
    bottom: '0',
    right: '0',
  }

  return (
    <Flex
      minH="100vh"
      pos="relative"
      alignItems="center"
      justifyContent="center"
      data-testid="Layout"
    >
      <Box {...absoluteBox} w="50%" display={{ base: 'none', lg: 'block' }}>
        <Box {...absoluteBox} bg="rebrand.01" />
        <Box position="relative" w="100%" h="100%">
          <Box as="img" src={curveImg} position="absolute" top="0" right="0" />
          <Box
            position="absolute"
            bottom="0"
            right="0"
            h="200px"
            w="100%"
            backgroundImage={frameImg}
            backgroundRepeat="repeat"
            backgroundSize="auto"
            backgroundPosition="bottom right"
            mixBlendMode="exclusion"
            opacity="0.2"
          />
        </Box>
      </Box>

      <Flex pos="relative" w="full" justifyContent="center" maxW="container.xl">
        {children}
      </Flex>
    </Flex>
  )
}

export default Layout
